import { createSlice } from "@reduxjs/toolkit";
import Swal from 'sweetalert2';
import { getLoyalty } from "./Utils/loyaltyUtils";

const initialState = {
    filters: {
        "filter[id]": "",
        "filter[user.name]": "",
        "filter[user.email]": "",
        "sort": "-id",
        "page": "",
    },
    loyalties: [],
    pagination: {},
    loading: false,
    error: null,
};
const loyaltySlice = createSlice({
    name: "loyalty",
    initialState,
    reducers: {
        setFilters: (state, action) => {
            state.filters = { ...state.filters, ...action.payload };
        },
        resetFilters: (state) => {
            state.filters = initialState.filters;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getLoyalty.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getLoyalty.fulfilled, (state, action) => {
                state.loading = false;
                state.loyalties = action.payload.data;
                state.pagination = action.payload.pagination;
            })
            .addCase(getLoyalty.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: action.payload,
                });
            });
    }
});
export const { setFilters, resetFilters } = loyaltySlice.actions;
export default loyaltySlice.reducer;
